import * as React from 'react';
import { ChoiceGroup } from "office-ui-fabric-react";
import { onRenderField, IChoiceGroupOptionExt } from './PrimaryScheduleSection';
import Link from '../../common/Link';

const SHIFT_KEY = 'shift';
const KEEP_KEY = 'keep';

export const ZeroDayMilestoneFsBehaviorSection = (props: {
    readonly?: boolean,
    value?: boolean,
    onChange: (value: boolean) => void
}) => {
    const options: IChoiceGroupOptionExt[] = [
        {
            key: SHIFT_KEY,
            text: 'Shift 0-duration task with FS predecessor to next working day (legacy)',
            onRenderField
        },
        {
            key: KEEP_KEY,
            text: 'Keep 0-duration task with FS predecessor on predecessor finish date (PMI-aligned)',
            onRenderField
        }
    ];

    return <div className="project-calculation-mode">
        <div className='section-description'>
            Select the behavior for 0-duration tasks with Finish-to-Start predecessors in the PPM Express schedule in the current project.
            It does not affect tasks with duration greater than 0 days or other dependency types.<br />
            Please refer to <Link href='https://help.ppm.express/projects/2082039-project-settings#section-10' target='_blank'>this article</Link> for more details.
        </div>
        <ChoiceGroup
            label='Mode'
            className="horizontal"
            disabled={props.readonly}
            selectedKey={(props.value ?? true) ? SHIFT_KEY : KEEP_KEY}
            options={options}
            onChange={(ev, option) => props.onChange(option?.key === SHIFT_KEY)}
        />
    </div>;
};
